import { render, staticRenderFns } from "./Timepiece.vue?vue&type=template&id=a8c87e14&"
import script from "./Timepiece.vue?vue&type=script&lang=js&"
export * from "./Timepiece.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports